export const BASE_URL = 'https://amplifierapp.xyz/api_u/'

export const ENDPOINTS = {
  LOGIN: 'login',
  SOCIAL_LOGIN: 'social_login',
  REGISTER: 'register',
  GET_PROFILE: 'get_profile',
  LOGIN_RESET: 'login_reset',
  LOGIN_RESET_VERIFY: 'login_reset_verify',
  UPDATE_PROFILE: 'edit_profile',
  CHANGE_PASSWORD: 'changepwd',
  MORE_APPS:'live_apps_inviteapp',

  GET_INVITATIONS: 'get_events_prod_signed', 
  GET_EVENT_TYPES:'get_event_type_settings',
  GET_INVITATION_DETAIL: 'get_members_invitation_prod', 
  GET_RECEIVED_INVITATION_DETAIL: 'get_detailed_event_prod',
  GET_NOTES_MEMBERS_EVENT_DETAIL: 'get_notes_members_event_detail',
  GET_GUESTS_LIST: 'guests_List', 
  ADD_GUEST: 'add_members_invitation', 
  EDIT_GUEST: 'update_contact', 
  DELETE_GUEST: 'delete_contact', 
  DELETE_GUEST_INVITATION: 'delete_member_invitation',
  GET_COHOSTS: 'friends',
  UPDATE_COHOSTS: 'invitation_cohosts_update',
  ADD_GUEST_AUTO: 'add_members_invitation_auto',
  GET_RECEIVED_INVITATIONS_PROFILE: 'get_profile_events_prod',


  GET_RECEIVED_INVITATIONS : 'get_invites_user_prod',
  GET_ALBUMS : 'get_album_events',
  GET_RECEIVED_ALBUMS :'get_invites_recieved_album_user',
  GET_ALBUM_PUBLIC :'get_album_public_photos_event',
  GET_ALBUM_PRIVATE :'get_album_private_photos_event',
  UPLOAD_ALBUM :'upload_album_photo_event',
  DELETE_ALBUM_IMAGE: 'delete_image_album_event',
  CHECK_HOST: 'check_host_invitation_login',
  GET_CONNECTIONS: 'invite_connections',
  GET_CONNECTIONS_STATS: 'invite_connections_rsvp_status',
  GET_CONNECTIONS_EVENTS: 'invite_connections_past',

  SAVE_FEEDBACK : 'share_feedback_event',
  UPDATE_FEEDBACK : 'update_feedback_event',
  FEEDBACK_LIST : 'get_feedbacks_event',

  CREATE_INVITATION: 'add_event_prod_presigned',
  UPDATE_INVITATION: 'update_event_prod_presigned',
  DELETE_INVITATION: 'delete_event',
  UPDATE_COHOST: 'invitation_cohosts_update',
  GET_EVENT_DETAIL :'get_members_invitation_prod',
  DETAIL_INVITATION: 'get_members_invitation_prod',
  
  // VENDORS (INVITATION DETAIL)
  NEARBY_VENDORS: 'nearby_photographers',
  SEND_INVITE_VENDORS: 'send_invite_vendors',
  UPDATE_INVITE_VENDOR_CATEGORIES: 'update_invite_vendor_categories',
  INVITE_HIRED_VENDORS: 'invite_hired_vendors',
  DELETE_HIRED_VENDORS: 'delete_invite_vendor',

  GET_POSTER_CATEGORIES: 'list_category_gif',
  GET_POSTERS: 'list_images_gif_category',
  GET_GIFS: 'https://tenor.googleapis.com/v2/search',
  GET_GIFHY: 'https://api.giphy.com/v1/gifs/search',

  SEND_INVITE: 'send_invite_member',
  RESEND_INVITE_MEMBER: 'resend_invite_member',

  SEND_INVITE_PHONE: 'send_invite_member_phone',
  RESEND_INVITE_MEMBER_PHONE: 'resend_invite_member_phone',

  CREATE_CONTACT: 'add_members_invitation',
  CREATE_CONTACT_NEW: 'add_other_contact_new',
  UPDATE_CONTACT: 'update_contact',
  DELETE_CONTACT: 'delete_contact',

  SEND_ENQUIRY: 'send_invite_enquiry',
  ENQUIRY_CATEGORIES_LIST:'list_contextual_category_enquiry',
  UPDATE_RSVP: 'update_adult_child_members_invitation',

  UPDATE_RSVP_GUEST:'update_rsvp_invitation',
  UPDATE_RSVP_LOGIN:'update_rsvp_invitation_login',
  GET_WEB_COUNT: 'get_web_counts_invitation',
  CHECK_EXIST_INVITATION:'check_member_existed_invitation',

  UPDATE_RECEIVED_RSVP: 'update_invite_user',
  UPDATE_EVENT_SETTINGS: 'update_event_settings',

  GUESTS_LIST: 'guests_List',

  CONTACTS_LIST: 'myContactsList', 
  FRIENDS_LIST: 'friends',
  ENQUIRIES_LIST: 'get_invite_enquiries',
  ENQUIRY_DETAIL: 'get_invite_enquiry_details',

  GET_VENDORS: 'list_sellers_contextual_category',
  GET_CATEGORIES_LIST: 'list_contextual_category',
  VENDOR_DETAIL: 'businessdetail',
  VENDOR_PRODUCTS: 'business_products',


  SCANNED: 'get_users_event_qrscan',  
  SAVE_SHARE_GUESTS: 'grant_album_access_invite_friends',
  UPDATE_ALBUM_SETTINGS: 'update_settings_album',
  UPLOAD_PERMISSIONS: 'invitation_album_upload_members_update',
  REMOVE_ACCESS: 'remove_invite_album_access',

  SEARCH_USER_INFO: 'search_users_info',
  SEND_REQUEST: 'send_request_contact',
  CANCEL_REQUEST: 'cancel_request',
  APPROVE_REQUEST: 'accept_request_contact'

}

 

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAdD7A3fCu3lEd1C6-8CVB9auiI3ClgMio',
  authDomain: 'primetime-f5611.firebaseapp.com',
  projectId: 'primetime-f5611',
  storageBucket: 'primetime-f5611.firebasestorage.app',
  messagingSenderId: '256112003489',
  appId: '1:256112003489:web:01be0a9f67716a165563e0',
}
